//import Sidebar from "../components/Sidebar";
//import GameCard from "./components/Gamecard";
//import SmallHeader from "./components/SmallHeader";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeader";
import { useNavigate, Link } from "react-router-dom";
//import "../../../assets/css/tp-style/Betprogames.css";

export default function RoyalStarDasboard() {
  const [balance, setBalance] = useState(0);
  const [username, setUsername] = useState("");
  const [expouser, setExpouser] = useState(0);

  const userInfo = useSelector((state) => state.userStore);

  useEffect(() => {
    setUsername(userInfo.data.uname);
    setBalance(parseInt(userInfo.data.bz_balance));
    setExpouser(parseInt(userInfo.data.opin_bal - userInfo.data.bz_balance));
    //}
  }, [userInfo, setUsername, setExpouser, setBalance]);

  return (
    <ClientLayoutWithOutHeader showLoader={false}>
      <section class="home-section">
        <style>{`  
        .bg-dream {
            background-image: url(/assets/images/royal_star/Newstar2.png);
            background-repeat: no-repeat;
            background-size: cover;
            background-attachment: fixed;
        }
      .home-section {
        position: relative;
        height: 100vh;
        left: 0;
        width: calc(100% - 0px);
        transition: all 0.1s ease;
    } 
    .bodyheight {
         
    }
    .center {
        text-align: center;
    }
    .container {
        text-align: center;
        width: 100%;
    }
    .container {
        max-width: 1000px;
    }
    .zoom {
        transition: transform .2s;
    }
    .square {
        margin: 12px;
        width: 22%;
        text-align: left;
        display: inline-block;
    }
    .card-img-top {
    width: 100%;
    border-top-left-radius: calc(0.25rem - 1px);
    border-top-right-radius: calc(0.25rem - 1px);
}
img {
    vertical-align: middle;
    border-style: none;
}
    @media screen and (min-width: 1200px) {
        .card-img-top {
            max-height: 140px;
            min-height: 124px;
        }
    }
    .HeaderContent--2QfCy {
        background-image: linear-gradient( 180deg, transparent 10%, rgba(0, 0, 0, .9) 98%);
        position: relative
    }
    
    .square {
        margin: 12px;
        width: 22%;
        text-align: left;
        display: inline-block
    }
    
    .container {
        text-align: center;
        width: 100%
    }
    
    .center {
        text-align: center
    }
    
    .zoom {
        transition: transform .2s
    }
    
    .zoom:hover {
        transform: scale(1.2)
    }
    
    .CategoryMenu--3haZ2:not(.fixed--1Zx7y).visible--3inF8 {
        opacity: 1
    }
    
    .CategoryMenu--3haZ2:not(.fixed--1Zx7y).desktop--34snD {
        background: 0 0
    }
    
    .CategoryMenu--3haZ2:not(.fixed--1Zx7y) {
        background: rgba(26, 26, 26, .5);
        opacity: 0
    }
    
    .desktop--34snD.CategoryMenu--3haZ2 {
        bottom: 0;
        font-size: .675em;
        left: 0;
        position: relative;
        right: 0
    }
    
    .Menu--15nYK.desktop--1fFFO {
        bottom: 6px;
        display: flex;
        flex-wrap: nowrap
    }
    
    .Menu--15nYK {
        -webkit-overflow-scrolling: touch;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-behavior: smooth;
        scrollbar-width: none;
        text-align: center;
        white-space: nowrap
    }
    
    .desktop--1fFFO .MenuItem--UoREs:first-child {
        margin-left: auto
    }
    
    .desktop--1fFFO .MenuItem--UoREs.active--26kNu,
    .desktop--1fFFO .MenuItem--UoREs:hover {
        opacity: 1
    }
    
    .desktop--1fFFO .MenuItem--UoREs {
        max-width: 11vw;
        min-width: calc(8vw + 1.5em - 6px);
        padding: 0 0 4px
    }
    
    .MenuItem--UoREs.active--26kNu {
        color: #96ffff
    }
    
    .MenuItem--UoREs {
        color: #fff;
        display: inline-block;
        min-width: 16em;
        opacity: .8;
        padding: 8px 0;
        position: relative;
        text-decoration: none;
        vertical-align: top;
        white-space: nowrap
    }
    
    .MenuIcon--Ix_pm.desktop--3f0Dt {
        flex: 1 0 0%;
        height: 5.5vw;
        max-height: 75px;
        min-height: 40px;
        min-width: 40px;
        width: 5.5vw
    }
    
    .MenuIcon--Ix_pm {
        -webkit-tap-highlight-color: transparent;
        background-repeat: no-repeat;
        background-size: 100% auto;
        display: flex;
        font-size: 1.2vmin;
        height: 7.8em;
        margin: auto;
        width: 7.8em
    }
    
    .Ribbon--PPbhT.new--Pg-ZR {
        background: #e81e45
    }
    
    .Ribbon--PPbhT.desktop--3mSjb {
        height: auto;
        left: 60%;
        top: .5em
    }
    
    .Ribbon--PPbhT {
        border-radius: 2px;
        height: 1rem;
        left: 65%;
        padding: .3rem .6rem;
        position: absolute;
        top: .75em;
        z-index: 1
    }
    
    .Category--2B0NG {
        flex: 1 1 0%;
        position: relative
    }
    
    .CategoryIcon--3E0_R {
        display: flex;
        height: 100%;
        position: absolute;
        transition: opacity 1s ease-in;
        width: 100%
    }
    
    .AllTabImg {
        display: flex;
        height: 100%;
        position: absolute;
        transition: opacity 1s ease-in;
        width: 100%;
        padding-top: 15px
    }
    
    .ezugiimg {
        display: flex;
        height: 100%;
        position: absolute;
        transition: opacity 1s ease-in;
        width: 100%
    }
    
    .OneTouchimg {
        display: flex;
        height: 100%;
        position: absolute;
        transition: opacity 1s ease-in;
        width: 100%
    }
    
    .betgameevo {
        display: flex;
        height: 100%;
        position: absolute;
        transition: opacity 1s ease-in;
        width: 100%;
        padding-top: 35px
    }
    
    .desktop--1fFFO .MenuItem--UoREs.active--26kNu img,
    .desktop--1fFFO .MenuItem--UoREs.active--26kNu svg,
    .desktop--1fFFO .MenuItem--UoREs:hover img,
    .desktop--1fFFO .MenuItem--UoREs:hover svg {
        transform: scale(1)
    }
    
    .MenuItem--UoREs.active--26kNu .IconFillActive,
    .MenuItem--UoREs.active--26kNu .IconFillActive--gnWuk {
        opacity: 1
    }
    
    .MenuIcon--Ix_pm.desktop--3f0Dt img,
    .MenuIcon--Ix_pm.desktop--3f0Dt svg {
        transform: scale(.8);
        transition: transform .25s ease-in-out
    }
    
    .desktop--1fFFO .IconFillActive,
    .desktop--1fFFO .IconFillActive--gnWuk,
    .desktop--1fFFO .IconFillPassive,
    .desktop--1fFFO .IconFillPassive--3VxN0 {
        transition: opacity .4s
    }
    
    .Menu--15nYK .IconFillActive,
    .Menu--15nYK .IconFillActive--gnWuk {
        fill: #fff;
        opacity: 0
    }
    
    .MenuIcon--Ix_pm img,
    .MenuIcon--Ix_pm svg {
        position: absolute;
        width: 100%
    }
    
    .desktop--1fFFO .MenuItem--UoREs.active--26kNu img,
    .desktop--1fFFO .MenuItem--UoREs.active--26kNu svg,
    .desktop--1fFFO .MenuItem--UoREs:hover img,
    .desktop--1fFFO .MenuItem--UoREs:hover svg {
        transform: scale(1)
    }
    
    .MenuItem--UoREs.active--26kNu .IconFillPassive,
    .MenuItem--UoREs.active--26kNu .IconFillPassive--3VxN0 {
        opacity: 0
    }
    
    .MenuIcon--Ix_pm.desktop--3f0Dt img,
    .MenuIcon--Ix_pm.desktop--3f0Dt svg {
        transform: scale(.8);
        transition: transform .25s ease-in-out
    }
    
    .desktop--1fFFO .IconFillActive,
    .desktop--1fFFO .IconFillActive--gnWuk,
    .desktop--1fFFO .IconFillPassive,
    .desktop--1fFFO .IconFillPassive--3VxN0 {
        transition: opacity .4s
    }
    
    .Menu--15nYK .IconFillPassive,
    .Menu--15nYK .IconFillPassive--3VxN0 {
        fill: #fff
    }
    
    .MenuIcon--Ix_pm img,
    .MenuIcon--Ix_pm svg {
        position: absolute;
        width: 100%
    }
    
    .left {
        width: 14vw;
        float: left;
        margin: 10px
    }
    
    .mainblock {
        padding-left: 26vw
    }
    
    @media screen and (max-width:850px) {
        .left {
            width: 34vw;
            float: left
        }
    }
    
    .card-img-top {
        max-height: 140px;
        min-height: 133px
    }
    
    @media screen and (min-width:1200px) {
        .card-img-top {
            max-height: 140px;
            min-height: 124px
        }
    }
    
    @media screen and (max-width:350px) {
        .card-img-top {
            max-height: 94px
        }
        .square {
            margin: 4px;
            width: 45%;
            text-align: left;
            display: inline-block
        }
    }
    
    @media screen and (max-width:635px) {
        .mobiletabs {
            margin-right: 14px;
            padding-left: 5vw
        }
        .square {
            margin: 4px;
            width: 45%;
            text-align: left;
            display: inline-block
        }
        .mainblock {
            padding-left: 1vw
        }
    }
    
    .card-body {
        padding: 0;
        text-align: center;
        max-height: 22px
    }
    
    h5 {
        font-size: 1rem
    }
    
    .mobiletabs :hover {
        cursor: pointer
    }
    `}</style>

        <div class="bg-dream bodyheight">
          <div class="center">
            <div style={{ display: "block" }}>
              <div id="serviceBox">
                <div class="container">
                  <div class="square">
                    <img src="/assets/images/royal_star/royalstarlogo.png" />
                  </div>
                </div>
                <div class="container" style={{ maxWidth: "1140px" }}>
                  <div class="square zoom">
                    <Link to="/royal-star/900001">
                      <img
                        src="/assets/images/royal_star/rg_7up_7down.webp"
                        class="card-img-top"
                        alt="7 Up Down"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900002">
                      <img
                        src="/assets/images/royal_star/rg_roulette.webp"
                        class="card-img-top"
                        alt="Auto Roulette"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900003">
                      <img
                        src="/assets/images/royal_star/rg_teen_patti.webp"
                        class="card-img-top"
                        alt="Teen Patti"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900004">
                      <img
                        src="/assets/images/royal_star/rg_dragon_tiger.webp"
                        class="card-img-top"
                        alt="Dragon Tiger"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900005">
                      <img
                        src="/assets/images/royal_star/rg_cricket_war.webp"
                        class="card-img-top"
                        alt="Cricket War"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900006">
                      <img
                        src="/assets/images/royal_star/baccarat.webp"
                        class="card-img-top"
                        alt="Baccarat"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900007">
                      <img
                        src="/assets/images/royal_star/rg_a3.webp"
                        class="card-img-top"
                        alt="Amar Akbar Anthony"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900008">
                      <img
                        src="/assets/images/royal_star/rg_3cards_judgement.webp"
                        class="card-img-top"
                        alt="3 Cards Judgement"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900009">
                      <img
                        src="/assets/images/royal_star/rg_casino_war.webp"
                        class="card-img-top"
                        alt="Casino War"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900010">
                      <img
                        src="/assets/images/royal_star/rg_worli_matka.webp"
                        class="card-img-top"
                        alt="Worli Matka"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900011">
                      <img
                        src="/assets/images/royal_star/rg_bollywood_casino.webp"
                        class="card-img-top"
                        alt="Bollywood Casino"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900012">
                      <img
                        src="/assets/images/royal_star/rg_lottery.webp"
                        class="card-img-top"
                        alt="Lottery"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900013">
                      <img
                        src="/assets/images/royal_star/rg_book_cricket.webp"
                        class="card-img-top"
                        alt="Book Cricket"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900014">
                      <img
                        src="/assets/images/royal_star/rg_high_low.webp"
                        class="card-img-top"
                        alt="HighLow"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900015">
                      <img
                        src="/assets/images/royal_star/rg_muflis_teenpatti.webp"
                        class="card-img-top"
                        alt="Muflis Teen Patti"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900019">
                      <img
                        src="/assets/images/royal_star/teen_patti_one_day.webp"
                        class="card-img-top"
                        alt="One Day Teenpatti"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900021">
                      <img
                        src="/assets/images/royal_star/rg_lucky7.webp"
                        class="card-img-top"
                        alt="Lucky7"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900023">
                      <img
                        src="/assets/images/royal_star/rg_arw.webp"
                        class="card-img-top"
                        alt="Akbar Romeo Walter"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900025">
                      <img
                        src="/assets/images/royal_star/rg_2card_tp.webp"
                        class="card-img-top"
                        alt="2 Cards Teenpatti"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900027">
                      <img
                        src="/assets/images/royal_star/dragon_tiger_one_day.webp"
                        class="card-img-top"
                        alt="Dragon Tiger One day"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900031">
                      <img
                        src="/assets/images/royal_star/rg_dtl.webp"
                        class="card-img-top"
                        alt="Dragon Tiger Lion"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900034">
                      <img
                        src="/assets/images/royal_star/side_bet_city.webp"
                        class="card-img-top"
                        alt="Side Bet City"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900037">
                      <img
                        src="/assets/images/royal_star/trio.webp"
                        class="card-img-top"
                        alt="Trio"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900039">
                      <img
                        src="/assets/images/royal_star/2_card_teen_patti_one day.webp"
                        class="card-img-top"
                        alt="2 Card Teen Patti One Day "
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900046">
                      <img
                        src="/assets/images/royal_star/center_card.webp"
                        class="card-img-top"
                        alt="Center Card "
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/900075">
                      <img
                        src="/assets/images/royal_star/roulette.webp"
                        class="card-img-top"
                        alt="Roulette"
                      />
                    </Link>
                  </div>
                  <div class="square zoom">
                    <Link to="/royal-star/903002">
                      <img
                        src="/assets/images/royal_star/sicbo_exclusive.webp"
                        class="card-img-top"
                        alt="Sicbo Exclusive"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ClientLayoutWithOutHeader>
  );
}
